/*
 * @Description: 引导页
 * @Author: ZY
 * @Date: 2021-01-21 20:13:03
 * @LastEditors: ZY
 * @LastEditTime: 2021-01-21 21:24:27
 */
import Layout from '@/layout/Index.vue';
import { shallowRef } from 'vue';
import { RouteRecordRaw } from 'vue-router';
const GuideRouter: Array<RouteRecordRaw> = [
  {
    path: '/guide',
    component: shallowRef(Layout),
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "guide" */ '@/views/guide/Index.vue'),
        name: 'Guide',
        meta: {
          title: 'guide',
          icon: '#iconguide'
        }
      }
    ]
  }
]
GuideRouter.length = 0;
export default GuideRouter
